import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';

export class ContractPriceResponse extends Model {
  @Expose()
  updatedAt: Date;
  @Expose()
  truckType: string;
  @Expose()
  truckTypeId: number;
  @Expose()
  productType: string;
  @Expose()
  productTypeId: number;
  @Expose()
  price: number;
  @Expose()
  updatedBy: string;
  @Expose()
  fleetPrice: number;
}
